// Generated by run_wave_continuum.py. Do not edit manually.
export const waveContinuumTimeline = {
  "palau": {
    "paccsap": [
      "1979-02-01",
      "1979-03-01",
      "1979-04-01",
      "1979-05-01",
      "1979-06-01",
      "1979-07-01",
      "1979-08-01",
      "1979-09-01",
      "1979-10-01",
      "1988-07-01"
    ],
    "era5": [
      "2023-02-01",
      "2023-03-01",
      "2023-04-01",
      "2023-05-01",
      "2023-06-01",
      "2023-07-01",
      "2023-08-01",
      "2023-09-01",
      "2023-10-01",
      "2023-11-01",
      "2023-12-01",
      "2024-01-01",
      "2024-02-01",
      "2024-03-01",
      "2024-04-01",
      "2024-05-01",
      "2024-06-01",
      "2024-07-01",
      "2024-08-01",
      "2024-09-01",
      "2024-10-01",
      "2024-11-01",
      "2024-12-01",
      "2025-01-01",
      "2025-02-01",
      "2025-03-01",
      "2025-04-01",
      "2025-05-01",
      "2025-06-01",
      "2025-07-01",
      "2025-08-01",
      "2025-09-01",
      "2025-11-01",
      "2025-12-01",
      "2026-01-01",
      "2026-02-01",
      "2026-03-01",
      "2026-04-01",
      "2026-05-01",
      "2026-06-01",
      "2026-07-01",
      "2026-08-01"
    ],
    "noaa": [
      "2026-08-27T12:00:00Z",
      "2026-08-27T18:00:00Z",
      "2026-08-27T21:00:00Z",
      "2026-08-28T00:00:00Z",
      "2026-08-28T03:00:00Z",
      "2026-08-28T06:00:00Z",
      "2026-08-28T09:00:00Z",
      "2026-08-28T12:00:00Z",
      "2026-08-28T15:00:00Z",
      "2026-08-28T18:00:00Z",
      "2026-08-28T21:00:00Z",
      "2026-08-29T00:00:00Z",
      "2026-08-29T03:00:00Z",
      "2026-08-29T06:00:00Z",
      "2026-08-29T09:00:00Z",
      "2026-08-29T12:00:00Z",
      "2026-08-29T15:00:00Z",
      "2026-08-29T18:00:00Z",
      "2026-08-29T21:00:00Z",
      "2026-08-30T00:00:00Z",
      "2026-08-30T03:00:00Z",
      "2026-08-30T06:00:00Z",
      "2026-08-30T09:00:00Z",
      "2026-08-30T12:00:00Z",
      "2026-08-30T15:00:00Z",
      "2026-08-30T18:00:00Z",
      "2026-08-30T21:00:00Z",
      "2026-08-31T00:00:00Z",
      "2026-08-31T03:00:00Z",
      "2026-08-31T06:00:00Z",
      "2026-08-31T09:00:00Z",
      "2026-08-31T12:00:00Z",
      "2026-08-31T15:00:00Z",
      "2026-08-31T18:00:00Z",
      "2026-08-31T21:00:00Z",
      "2026-09-01T00:00:00Z",
      "2026-09-01T03:00:00Z",
      "2026-09-01T06:00:00Z",
      "2026-09-01T09:00:00Z",
      "2026-09-01T12:00:00Z",
      "2026-09-01T15:00:00Z",
      "2026-09-01T18:00:00Z",
      "2026-09-01T21:00:00Z",
      "2026-09-02T00:00:00Z",
      "2026-09-02T03:00:00Z",
      "2026-09-02T06:00:00Z",
      "2026-09-02T09:00:00Z",
      "2026-09-02T12:00:00Z",
      "2026-09-02T15:00:00Z",
      "2026-09-02T18:00:00Z",
      "2026-09-02T21:00:00Z",
      "2026-09-03T00:00:00Z",
      "2026-09-03T03:00:00Z",
      "2026-09-03T06:00:00Z",
      "2026-09-03T09:00:00Z",
      "2026-09-03T12:00:00Z",
      "2026-09-03T15:00:00Z",
      "2026-09-03T18:00:00Z",
      "2026-09-03T21:00:00Z",
      "2026-09-04T00:00:00Z",
      "2026-09-04T03:00:00Z",
      "2026-09-04T06:00:00Z"
    ]
  },
  "rmi": {
    "paccsap": [],
    "era5": [
      "2023-02-01",
      "2023-03-01",
      "2023-04-01",
      "2023-05-01",
      "2023-06-01",
      "2023-07-01",
      "2023-08-01",
      "2023-09-01",
      "2023-10-01",
      "2023-11-01",
      "2023-12-01",
      "2024-01-01",
      "2024-03-01",
      "2024-04-01",
      "2024-05-01",
      "2024-06-01",
      "2024-07-01",
      "2024-08-01",
      "2024-09-01",
      "2024-10-01",
      "2024-11-01",
      "2024-12-01",
      "2025-01-01",
      "2025-02-01",
      "2025-03-01",
      "2025-04-01",
      "2025-05-01",
      "2025-06-01",
      "2025-07-01",
      "2025-08-01",
      "2025-09-01",
      "2025-10-01",
      "2025-11-01",
      "2025-12-01",
      "2026-01-01",
      "2026-02-01",
      "2026-03-01",
      "2026-04-01",
      "2026-05-01",
      "2026-06-01",
      "2026-07-01",
      "2026-08-01"
    ],
    "noaa": [
      "2026-08-27T12:00:00Z",
      "2026-08-27T18:00:00Z",
      "2026-08-27T21:00:00Z",
      "2026-08-28T00:00:00Z",
      "2026-08-28T03:00:00Z",
      "2026-08-28T06:00:00Z",
      "2026-08-28T09:00:00Z",
      "2026-08-28T12:00:00Z",
      "2026-08-28T15:00:00Z",
      "2026-08-28T18:00:00Z",
      "2026-08-28T21:00:00Z",
      "2026-08-29T00:00:00Z",
      "2026-08-29T03:00:00Z",
      "2026-08-29T06:00:00Z",
      "2026-08-29T09:00:00Z",
      "2026-08-29T12:00:00Z",
      "2026-08-29T15:00:00Z",
      "2026-08-29T18:00:00Z",
      "2026-08-29T21:00:00Z",
      "2026-08-30T00:00:00Z",
      "2026-08-30T03:00:00Z",
      "2026-08-30T06:00:00Z",
      "2026-08-30T09:00:00Z",
      "2026-08-30T12:00:00Z",
      "2026-08-30T15:00:00Z",
      "2026-08-30T18:00:00Z",
      "2026-08-30T21:00:00Z",
      "2026-08-31T00:00:00Z",
      "2026-08-31T03:00:00Z",
      "2026-08-31T06:00:00Z",
      "2026-08-31T09:00:00Z",
      "2026-08-31T12:00:00Z",
      "2026-08-31T15:00:00Z",
      "2026-08-31T18:00:00Z",
      "2026-08-31T21:00:00Z",
      "2026-09-01T00:00:00Z",
      "2026-09-01T03:00:00Z",
      "2026-09-01T06:00:00Z",
      "2026-09-01T09:00:00Z",
      "2026-09-01T12:00:00Z",
      "2026-09-01T15:00:00Z",
      "2026-09-01T18:00:00Z",
      "2026-09-01T21:00:00Z",
      "2026-09-02T00:00:00Z",
      "2026-09-02T03:00:00Z",
      "2026-09-02T06:00:00Z",
      "2026-09-02T09:00:00Z",
      "2026-09-02T12:00:00Z",
      "2026-09-02T15:00:00Z",
      "2026-09-02T18:00:00Z",
      "2026-09-02T21:00:00Z",
      "2026-09-03T00:00:00Z",
      "2026-09-03T03:00:00Z",
      "2026-09-03T06:00:00Z",
      "2026-09-03T09:00:00Z",
      "2026-09-03T12:00:00Z",
      "2026-09-03T15:00:00Z",
      "2026-09-03T18:00:00Z",
      "2026-09-03T21:00:00Z",
      "2026-09-04T00:00:00Z",
      "2026-09-04T03:00:00Z",
      "2026-09-04T06:00:00Z"
    ]
  }
};

export const waveContinuumSources = {
  "paccsap": {
    "label": "CSIRO/CAWCR PACCSAP hindcast",
    "kind": "historical hindcast",
    "resolution": "4 arc-minute Western Pacific nest (~7 km)",
    "coverage": "1979-02 through 2023-01",
    "citation": "Durrant et al. (2019), CAWCR Wave Hindcast / PACCSAP"
  },
  "era5": {
    "label": "ERA5 wave reanalysis",
    "kind": "reanalysis bridge",
    "resolution": "0.25 degree ERA5 single-level wave fields",
    "coverage": "2023-02 through present minus the ERA5 release lag",
    "citation": "ECMWF Copernicus Climate Change Service, ERA5"
  },
  "noaa": {
    "label": "NOAA/NCEP WW3",
    "kind": "operational analysis and forecast",
    "resolution": "0.25 degree global WW3",
    "coverage": "latest model run only",
    "citation": "NOAA/NCEP WAVEWATCH III operational guidance"
  }
};
